import { useState } from "react";

function MaskedField({ value }) {
  const [revealed, setRevealed] = useState(false);
  const display = revealed ? value : "•".repeat(Math.max((value || "").length, 4));
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-semibold text-slate-800 tracking-wider">
        {display}
      </span>
      <button
        onClick={() => setRevealed((r) => !r)}
        className="text-[10px] font-bold uppercase tracking-wide text-slate-500 border border-slate-200 rounded px-2 py-0.5 hover:bg-slate-50 hover:text-slate-800 transition-all"
      >
        {revealed ? "Hide" : "Show"}
      </button>
    </div>
  );
}

export default MaskedField;